"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BageType", {
  enumerable: true,
  get: function get() {
    return _constants.BageType;
  }
});
exports.SearchRecommendBadge = SearchRecommendBadge;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _Label = _interopRequireDefault(require("@material-ui/icons/Label"));
var _classnames = _interopRequireDefault(require("classnames"));
var _RecipientBadge = _interopRequireDefault(require("../EmailInput/RecipientBadge"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../utils/constants.js");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var BAGE_MAX_PERCENTAGE = 0.75;
var labeIconNode = /*#__PURE__*/_react["default"].createElement(_Label["default"], {
  style: {
    fontSize: 24
  }
});
function SearchRecommendBadge(props) {
  var options = props.options,
    _onClose = props.onClose;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isScroll = _useState2[0],
    setIsScroll = _useState2[1];
  (0, _react.useEffect)(function () {
    if (options.length) {
      var selfNode = document.querySelector('#searchBadge');
      var parentNode = selfNode && selfNode.parentNode;
      var parentWidth = parentNode && parentNode.clientWidth;
      var selfWidth = selfNode && selfNode.clientWidth;
      if (selfNode.scrollWidth > selfNode.clientWidth) {
        selfNode.scrollTo({
          left: selfNode.scrollWidth,
          behavior: 'smooth'
        });
        setIsScroll(true);
        return;
      }
      if (parentWidth && selfWidth / parentWidth >= BAGE_MAX_PERCENTAGE) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
      return;
    }
    setIsScroll(false);
  }, [options, isScroll]);
  if (!options.length) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "searchBadge",
    className: (0, _classnames["default"])({
      'w-2/3 flex flex-no-wrap disable-scrollbars overflow-x-scroll': isScroll
    })
  }, options.map(function (_ref) {
    var type = _ref.type,
      item = _ref.item;
    return /*#__PURE__*/_react["default"].createElement(_RecipientBadge["default"], {
      iconCls: "mx-3",
      iconSize: "24",
      className: (0, _classnames["default"])('!h-12 mx-1 !my-0 text-xl', {
        'relative pl-12': _constants.BageType.Contact === type
      }),
      avater: _constants.BageType.Contact === type ? item.avater : _constants.BageType.Label ? labeIconNode : '',
      name: item.name,
      email: _constants.BageType.Contact === type ? item.email : '',
      onClose: function onClose() {
        _onClose(item, type);
      }
    });
  }));
}
//# sourceMappingURL=SearchBadge.js.map